<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      DEPOSIT REQUEST
    </div>
    <div class="card-body">
      <form [formGroup]="depositForm">
        <div class="container">
          <p
            *ngIf="errorMsg"
            class="alert alert-danger m-1 p-1"
          >
            {{ errorMsg }}
          </p>
          <div *ngIf="is_gpayActive" class="form-group">
            <label>
              <input type="radio" formControlName="method" value="gpay" (click)="toggleUpiTextbox()" (change)="chooseMethod($event)" [(ngModel)]="methodval"> Google Pay
            </label>
          </div>
          <div *ngIf="is_paytmActive" class="form-group">
            <label>
              <input type="radio" formControlName="method" value="paytm" (click)="toggleUpiTextbox()" (change)="chooseMethod($event)" [(ngModel)]="methodval"> PayTm
            </label>
          </div>
          <div *ngIf="is_phonepeActive" class="form-group">
            <label>
              <input type="radio" formControlName="method" value="phonepe" (click)="toggleUpiTextbox()" (change)="chooseMethod($event)" [(ngModel)]="methodval"> Phonepe
            </label>
          </div>
          <div *ngIf="is_qrActive" class="form-group">
            <label>
              <input type="radio" formControlName="method" value="qrcode" (click)="toggleUpiTextbox()" (change)="chooseMethod($event)" [(ngModel)]="methodval"> Qr code
            </label>
          </div>
          <div *ngIf="is_otherActive" class="form-group">
            <label>
              <input type="radio" formControlName="method" value="other" (click)="toggleUpiTextbox()" (change)="chooseMethod($event)" [(ngModel)]="methodval"> Bank

            </label>
          </div>
          <span
            class="text-danger"
            *ngIf="
                depositFormControl.method.touched &&
                depositFormControl.method.errors?.required">
              Please select method.
          </span>
          <div class="paybox font-weight-bold text-center1 m-2" style="font-size: 15px; ">
            <img *ngIf="selected_radio=='qrcode';else elseIfblock;" style="width:150px" [src]="qrcode">
            <ng-template #elseIfblock>
              <span *ngIf="selected_radio=='other';else elseBlock;" [innerHtml]="currentPayment"></span>
            </ng-template>
            <ng-template #elseBlock>
              {{currentPayment}}
            </ng-template>
            <a *ngIf="selected_radio=='qrcode';else elseIfblock2;" href="{{this.qrcode}}" class="material-symbols-outlined copybtn" style="float: right; cursor: grabbing;" target="_blank" download>
              download
            </a>
            <ng-template #elseIfblock2>
            <span (click)="copyMessage(currentPayment)" class="material-symbols-outlined copybtn" style="float: right; cursor: copy;">
              content_copy
            </span>
            </ng-template>
          </div>
          <div class="form-group" *ngIf="showUpiTextbox">
            <label for="inputName">UTR/Reference No.</label>
            <input type="text" formControlName="transaction_id" class="form-control" name = "transaction_id"
                   placeholder="Enter UTR/Ref. No.">
            <span
              class="text-danger"
              *ngIf=" showUpiTextbox &&
                depositFormControl.transaction_id.touched &&
                depositFormControl.transaction_id.errors?.required">
              UTR/Ref. No. is required
            </span>
          </div>
          <div class="form-group">
            <label for="inputName">Amount</label>
            <input type="number" formControlName="amount" class="form-control" id="inputName"
                   placeholder="Enter amount">
            <span
              class="text-danger"
              *ngIf="
                depositFormControl.amount.touched &&
                depositFormControl.amount.errors?.required">
              Amount is required
            </span>
          </div>

          <div class="form-group">
            <label>Upload Screenshot</label>
            <input type="file" formControlName="depo_proof" (change)="onFileSelected($event)" class="form-control"
                   placeholder="Upload screenshot">
            <span
              class="text-danger"
              *ngIf="
                (depositFormControl.depo_proof.touched ) &&
                depositFormControl.depo_proof.errors?.required">
              Please upload screenshot
            </span>
          </div>

          <!-- <div class="form-group">
            <label>Username</label>
            <input type="text" formControlName="username" class="form-control"
                   placeholder="Enter Username">
            <div
              *ngIf="depositFormControl.username.touched && depositFormControl.username.errors"
              class="help-block text-danger"
            >
              <div class="help-block text-danger" *ngIf="depositFormControl.username.errors.required">
                Username is required
              </div>
            </div>
          </div> -->
          <input type="hidden" formControlName="username">
          <div class="text-left">
            <button class="btn btn-danger" (click)="dismiss()">CANCEL</button>
            <button class="btn btn-success ml-2" (click)="addDepositRequest()">SUBMIT</button>
          </div>
          <!--        <div class="container" style="text-align:center;"><a style="color:yellow;">Forgot password?</a></div>-->
          <!--        <div class="text-center" style="margin: -3.5%;">-->
          <!--          <button class="btn rounded-pill button_new " (click)="register()">Register</button>-->
          <!--        </div>-->
        </div>
      </form>
    </div>
  </div>
  <!--  <div class="d-flex justify-content-between">-->
  <!--    <h3 class="text-warning">Bet Slip</h3>-->
  <!--    <span (click)="closeDialog()" class="material-symbols-outlined">close</span>-->
  <!--  </div>-->
</div>
